import React, { useCallback, useEffect, useRef, useState } from "react";
import $ from "jquery";
import axios from "axios";
import { AP_Master } from "../Configuration/API_URL";
import LoaderForSearch from "./Common/LoaderForSearch";
import { toast } from "react-toastify";
import {
  AESEncryption,
  ApiResDecrypt,
  onlyAlphaNumeric,
} from "../CommonMethhods/CommonMethods";

function SearchCommon(props) {
  const [clientList, setClientList] = useState([]);
  const [scrollLoader, setScrollLoader] = useState(false);
  const [scroll, setScroll] = useState(false);
  const [count, setCount] = useState();
  const [page, setPage] = useState(1);
  const [apCode, setApCode] = useState("");
  const [subApCode, setSubApCode] = useState("");

  const storeToken = localStorage.getItem("ssoToken");
  const projectRole = JSON.parse(localStorage.getItem("project"));
  const getRole = projectRole[0]?.Role?.Name;

  const forUpdateName = (data) => {
    // debugger;
    if (data === false) {
      setApCode("");
      setSubApCode("");

      if (document.getElementById("SubApSearch-id")) {
        document.getElementById("SubApSearch-id").value = "";
      }
      document.getElementById(`ApSearch-id`).value = "";
      return;
    }

    const { apCode, masterAP, apName } = data;
    if (apCode) {
      setApCode(apCode.replaceAll(" ", ""));
      document.getElementById(`ApSearch-id`).value = apName;
    }
    if (masterAP) {
      setSubApCode(masterAP.replaceAll(" ", ""));
      document.getElementById("SubApSearch-id").value = masterAP;
    }

    // setSubApCode(MasterAp.replaceAll(" ", ""));
    // // setApName(Name);

    // if (props.api === "ApSearch") {
    // apNameRef.current.value = Name;
    // } else if (props.api === "SubApSearch") {
    // apNameRef.current.value = MasterAp;
    // }
  };

  function clientSet(name, code, i, flag) {
    if (name === "Data not found") {
      $(`.write-search.${props.api}`).addClass("show-result scroll-table");
    } else {
      $(`.write-search.${props.api}`).removeClass("show-result");
      setClientList([]);
      document.getElementById(`${props.api}-id`).value = name;
      // apNameRef.current.value = `${name}`;

      if (props.master === "ApMaster" && flag === "Yes") {
        // props.forFlagActive(true);
        forUpdateName(false);
        toast.error("Ap already exist please choose another");
      }
      // else {
      //         props.forFlagActive(false);
      //       }

      if (props.api === "ApSearch") {
        setApCode(code);
      } else if (props.api === "SubApSearch") {
        setSubApCode(code);
      }

      if (props.master === "ClientMaster" && code) {
        props.GetClientCodes(code);
      }
      setScrollLoader(false);
    }
  }
  async function searchApCode(e) {
    $(`.write-search.${props.api}`).addClass("show-result scroll-table");
    let payloadValue = {
      searchKeyword: e,
      pageNo: page === 0 ? 1 : page,
      pageSize: 10,
    };
    let encPayload = AESEncryption(payloadValue);
    try {
      const getSearchDetail = await axios.post(
        props.master === "ClientMaster"
          ? AP_Master.Get_ClientAp_Code_URL
          : AP_Master.Get_Ap_Codes_URL,

        `"${encPayload}"`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${storeToken}`,
            reserv: 1,
          },
        }
      );
      const res = ApiResDecrypt(getSearchDetail?.data);
      console.log(res, "eresdfs");
      if (res.status === 0) {
        setCount(res.data.totalCount);
        if (scroll == true) {
          props.master === "ClientMaster"
            ? setClientList((prev) => {
                return [...prev, ...res.data.clientApCodes];
              })
            : setClientList((prev) => {
                return [...prev, ...res.data.apcodes];
              });
        } else {
          props.master === "ClientMaster"
            ? setClientList(res.data.clientApCodes)
            : setClientList(res.data.apcodes);
        }
      } else {
        props.master === "ClientMaster"
          ? setClientList([
              { clientApName: "Data not found", clientApCode: null },
            ])
          : setClientList([{ apName: "Data not found", apCode: null }]);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setScrollLoader(false);
    }
  }
  async function searchSabApCode(e) {
    $(`.write-search.${props.api}`).addClass("show-result scroll-table");
    let payloadValue = {
      searchKeyword: e,
      pageNo: page === 0 ? 1 : page,
      pageSize: 10,
    };
    let encPayload = AESEncryption(payloadValue);
    try {
      const getSearchDetail = await axios.post(
        AP_Master.Get_Master_Codes_URL,
        `"${encPayload}"`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${storeToken}`,
            reserv: 1,
          },
        }
      );
      const res = ApiResDecrypt(getSearchDetail?.data);

      setCount(res.data.totalCount);
      if (res.message == "Data not found") {
        setClientList([{ apName: "Data not found", apCode: null }]);
      } else {
        if (scroll == true) {
          setClientList((prev) => {
            return [...prev, ...res.data.apcodes];
          });
        } else {
          setClientList(res.data.apcodes);
        }
      }
    } catch (error) {
      console.log(error);
    } finally {
      setScrollLoader(false);
    }
  }
  const handleClientName = (e) => {
    // props.clientCodeRef.current.value = {};
    props.master === "ClientMaster" && props.onChangeClientDropdownReset();

    setScrollLoader(false);
    if (e.target.value) {
      setClientList([]);
      setScroll(false);
      e.target.value = e.target.value.toUpperCase();
      if (e.target.value.length > 0) {
        setPage(1);
        setClientList([]);
        setScroll(false);

        if (props.api === "ApSearch") {
          searchApCode(e.target.value);
        } else if (props.api === "SubApSearch") {
          searchSabApCode(e.target.value);
        }
      }
    } else {
      setPage(1);
      setClientList([]);
      // setApName("");
      document.getElementById(`${props.api}-id`).value = "";

      // apNameRef.current.value = "";

      setApCode("");
      setSubApCode("");

      setScroll(false);
      $(".write-search.apSearch").removeClass("show-result");
    }
    $(".write-search.apSearch-li").click(function () {
      $(".write-search.apSearch").addClass("show-result scroll-table");
    });

    if (props.subApDropDown == "true") {
      if (e.target.value) {
        setClientList([]);
        setScroll(false);
        e.target.value = e.target.value.toUpperCase();
        // apNameRef.current.value = e.target.value.toUpperCase();
        if (e.target.value.length > 0) {
          setPage(1);
          setClientList([]);
          setScroll(false);
          if (props.api === "ApSearch") {
            searchApCode(e.target.value);
          } else if (props.api === "SubApSearch") {
            searchSabApCode(e.target.value);
          }
          // searchApCode(e.target.value);
        }
      } else {
        setPage(1);
        setClientList([]);
        // setApName("");

        document.getElementById(`${props.api}-id`).value = "";
        setApCode("");
        setSubApCode("");
        setScroll(false);
        $(".write-search.apSearch").removeClass("show-result");
      }
      $(".write-search.apSearch-li").click(function () {
        $(".write-search.apSearch").addClass("show-result scroll-table");
      });
    }
  };
  const handleScroll = async () => {
    setScroll(true);
    const a = document.querySelector(`#${props.api}`);
    if (a.scrollTop + a.offsetHeight + 1 >= a.scrollHeight) {
      if (count <= page * 10) {
        setScrollLoader(false);
        return;
      }
      setPage((prev) => prev + 1);
      setScrollLoader(true);
    }
  };
  useEffect(() => {
    if (page > 1) {
      // searchApCode(apName);
      if (props.api === "ApSearch") {
        // searchApCode(e.target.value);
        searchApCode(document.getElementById(`${props.api}-id`).value);
      } else if (props.api === "SubApSearch") {
        let subApValue = document.getElementById(`${props.api}-id`).value;
        searchSabApCode(subApValue);
      }
      // searchApCode(apNameRef.current.value);
    }
  }, [page]);

  const forCloseLi = (data) => {
    setClientList(data);
  };
  props.hiRef.forUpdateName = forUpdateName;

  // useEffect(() => {}, []);
  if (props.api === "ApSearch") {
    props.forGetApCode(apCode);
  } else if (props.api === "SubApSearch") {
    props.forGetSubApCode(subApCode);
  }

  props.hiRef.forCloseLi = forCloseLi;
  return (
    <div className="rm-custom-dropdown">
      <input
        type="text"
        name="search-text"
        className={`input-st ap  ${props.errorMain ? "invalid" : ""}`}
        placeholder="Search by Name/Code..."
        autoComplete="off"
        // ref={apNameRef}
        id={`${props.api}-id`}
        // readOnly={props.submitBtn ? false : true}
        onChange={(e) => {
          handleClientName(e);
        }}
        disabled={getRole !== "FranchiseManager"}
        onInput={(e) => onlyAlphaNumeric(e)}
      />
      <ul
        className={`write-search ${props.api} border-0`}
        id={props.api}
        onScroll={handleScroll}
      >
        {clientList.map((item, i) => (
          <li
            key={i}
            onClick={() => {
              setPage(0);
              props.master === "ClientMaster"
                ? clientSet(item.clientApName, item.clientApCode, i, item.flag)
                : clientSet(item.apName, item.apCode, i, item.flag);
            }}
          >
            {props.master === "ClientMaster" ? (
              <>
                <div>{item.clientApName}</div>
                <div> {item.clientApCode}</div>
              </>
            ) : (
              <>
                <div>{item.apName}</div>
                <div> {item.apCode}</div>
              </>
            )}
          </li>
        ))}
        {scrollLoader && (
          <div className="loader-center">
            <LoaderForSearch />
          </div>
        )}
      </ul>
    </div>
  );
}

export default SearchCommon;
